import _Promise from "babel-runtime/core-js/promise";
import _regeneratorRuntime from "babel-runtime/regenerator";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";

var GROUP_ID = "";

var MODULE_ID = "";

var SAVE_PATH = "";

var initFieldConfig = function initFieldConfig(_this) {
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
  if (vm.$basecfg.isMobileFlag) {
    _this.groupDatas[GROUP_ID][MODULE_ID][0].isCustomModuleTitle = "1";
    _this.groupDatas[GROUP_ID][MODULE_ID][0].MODULE_TITLE = "";
  } else {
    fields.OCR_ITEM.isLongItem = true;
  }
  if (_this.oppBusiData.hasAppvTask1) {
    fields.OCR_ITEM.FIELD_CONTROL = "2";
  }
};

var backfillHistoryData = function backfillHistoryData(_this) {
  var otherAgentInfo = _.cloneDeepGet(_this.historyData, SAVE_PATH);
  if (!_.isEmpty(otherAgentInfo)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], otherAgentInfo);
  }
};

var NODE = {
  getGroupId: function getGroupId() {
    return GROUP_ID;
  },

  getModuleId: function getModuleId() {
    return MODULE_ID;
  },

  init: function init(_this) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    GROUP_ID = params.groupId;
    MODULE_ID = params.moduleId;
    SAVE_PATH = params.savePath;
  },

  beforeLoadBiz: function beforeLoadBiz(_this) {

    initFieldConfig(_this);
  },

  afterLoadBiz: function afterLoadBiz(_this) {
    backfillHistoryData(_this);
  },

  beforeSave: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this, params) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeSave(_x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return beforeSave;
  }(),
  afterSave: function afterSave(_this, newData) {
    if (_this.$store.state.mobileLogin) {
      consoleLog("手机端登录不上传ocr");
      return;
    }

    var ocrFieldRef = _this.$refs.IMPORTANT_MODULE_OCR10[0].$refs.OCR_ITEM[0];
    return _Promise.all([ocrFieldRef.uploadImgList(ocrFieldRef.collectedImgData)]).then(function (res) {
      consoleLog("工商营业执照上传成功", res);
    }).catch(function (err) {
      _this.alert("代理人身份证明文件上传失败");
      throw "代理人身份证明文件上传失败";
    });
  },
  validate: function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(_this) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function validate(_x4) {
      return _ref2.apply(this, arguments);
    }

    return validate;
  }(),

  pageActivated: function pageActivated(_this, groupId) {
    if (vm.$basecfg.isMobileFlag) {
      _this.$router.updateRoute(_this.$router.getCurrentRouteIndex(), "nextBtnText", "确认采集");
    }
  },
  beforeSkipBiz: function beforeSkipBiz(_this) {}
};

export default NODE;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS420/bizOcrInfo/bizOrgOcr.js
// module id = 151
// module chunks = 2